module.exports = __webpack_public_path__ + "static/img/bg1.a12c91a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg1.jpg
// module id = POXA
// module chunks = 1